

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import { MasterModule } from '@/app/store/modules/master'
import { UserReportModule } from '@/app/store/modules/userReport'

@Component({
  components: {
    search: Search,
  },
})
export default class extends Vue {
  @Prop({}) public isDisabled: boolean | undefined
  @Prop({}) public linkExport
  @Prop({}) public funcSearch
  @Prop({}) public isDisabledExport

  @Watch('onClearInputSearch')
  private onChangeClearInput(value: boolean, oldValue: boolean) {
    // console.log('as')
    this.salesman = ''
  }

  // Search
  public text: string = ''
  private resetSearch() {
    this.salesman = ''
    this.funcSearch(this.text)
  }

  public salesman: string = ''
  public salesmanCode(text) {
    const salesCode = this.salesmansCode.find((e) => e.sales_code === text)
    const index = this.salesmansCode.indexOf(salesCode)
    if (text.length > 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getSalesman()
    }
  }
  public salesmansCode: any = []
  public get salesmanCodeData(): any {
    this.salesmansCode = MasterModule.SalesmanData.data
    return MasterModule.SalesmanData
  }

  public get getUserData(): any {
    return UserReportModule.getUserData
  }

  private onClearFilter: boolean = false
  private clearFilter() {
    if (this.onClearFilter === false) {
      this.onClearFilter = true
    } else {
      this.onClearFilter = false
    }
  }
}
